export default {
  id: 'RegistrationAgreement',
  code: 'CN',
  text: {
    'Updated Successfully!': '更新成功!',
    'Failed to update!': '更新失败！',
    'Student Registration Terms and Conditions': '学员报名须知与条款',
    'Save': '保存',
    'Apply to student self-registration form': '在学员在自主注册表格显示此条款'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/RegistrationAgreement/locale.js